module.exports = __webpack_public_path__ + "static/media/h.31446eda.webp";